module.exports = __webpack_public_path__ + "img/w26-b1.e8160b74.jpg";